import { FC, ReactNode } from 'react';
import { Tooltip } from 'antd';

import classes from './IssueCard.module.scss';

interface IssueCardHeaderProps {
  title: string;
  children?: ReactNode;
  spanProps?: React.HTMLAttributes<HTMLSpanElement>;
  onTitleClick?: () => void;
  id?: string;
  /** 제목 바로 옆에 표시되는 배지 (예: caseKind 라벨 태그) */
  badge?: ReactNode;
}

const IssueCardHeader: FC<IssueCardHeaderProps> = ({ title, children, spanProps, onTitleClick, id, badge }) => {
  return (
    <div className={classes.header}>
      <div className={classes.titleGroup}>
        <Tooltip title={id}>
          <span
            className={`${classes.title} ${onTitleClick ? classes.clickable : ''}`}
            {...spanProps}
            onClick={onTitleClick}
          >
            {title}
          </span>
        </Tooltip>
        {badge}
      </div>
      {children}
    </div>
  );
};

export default IssueCardHeader;
